/* Elyon Dubai, OF01 Offer Page Scripts */

// ── Mobile hamburger menu ────────────────────────────────────
(() => {
  const toggle = document.getElementById('navToggle');
  const nav = document.getElementById('siteNav');
  if (!toggle || !nav) return;

  const close = () => {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    nav.classList.remove('is-open');
  };
  const open = () => {
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    nav.classList.add('is-open');
  };

  toggle.addEventListener('click', () => {
    (toggle.getAttribute('aria-expanded') === 'true' ? close : open)();
  });
  nav.querySelectorAll('.site-nav-link').forEach(a => a.addEventListener('click', close));
})();

// ── Swiper Gallery ──────────────────────────────────────────
const swiperThumbs = new Swiper('#swiperThumbs', {
  slidesPerView: 4,
  spaceBetween: 6,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
});

const swiperMain = new Swiper('#swiperMain', {
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '#galleryNext',
    prevEl: '#galleryPrev',
  },
  thumbs: {
    swiper: swiperThumbs,
  },
  on: {
    slideChange: handleSlideChange,
  },
});

// ── Gallery video logic ──────────────────────────────────────
const galleryVideos = [];

function handleSlideChange() {
  // Pause all gallery videos when navigating
  galleryVideos.forEach(({ vid, play, sound }) => {
    if (!vid) return;
    vid.pause();
    vid.muted = true;
    if (play) play.style.display = 'flex';
    if (sound) sound.style.display = 'none';
  });
}

galleryVideos.forEach(({ vid, play, sound }) => {
  if (!vid || !play) return;

  play.addEventListener('click', () => {
    if (vid.paused) {
      vid.play().catch(() => {});
      play.style.display = 'none';
      if (sound) sound.style.display = 'flex';
    }
  });

  if (sound) {
    sound.addEventListener('click', (e) => {
      e.stopPropagation();
      vid.muted = !vid.muted;
      sound.textContent = vid.muted ? '🔇 Tap to unmute' : '🔊 Muted';
    });
  }
});

// ── Tabs ────────────────────────────────────────────────────
document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.tab-pane').forEach(p => p.classList.remove('active'));
    btn.classList.add('active');
    const pane = document.getElementById('pane-' + btn.dataset.tab);
    if (pane) pane.classList.add('active');
  });
});

// ── Tab videos ───────────────────────────────────────────────
[
  { vid: 'tabVid',   play: 'tabVidPlay',   unmute: 'tabVidUnmute' },
  { vid: 'storyVid', play: 'storyVidPlay', unmute: 'storyVidUnmute' },
].forEach(({ vid: vidId, play: playId, unmute: unmuteId }) => {
  const vid    = document.getElementById(vidId);
  const play   = document.getElementById(playId);
  const unmute = document.getElementById(unmuteId);
  if (!vid || !play) return;

  play.addEventListener('click', () => {
    vid.play().catch(() => {});
    play.style.display = 'none';
    if (unmute) unmute.classList.add('visible');
  });

  if (unmute) {
    unmute.addEventListener('click', () => {
      vid.muted = !vid.muted;
      unmute.innerHTML = vid.muted ? '🔇 Tap to unmute' : '🔊 Muted';
    });
  }
});

// ── FAQ Accordion ────────────────────────────────────────────
document.querySelectorAll('.faq-q').forEach(btn => {
  btn.addEventListener('click', () => {
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    // Close all
    document.querySelectorAll('.faq-q').forEach(b => {
      b.setAttribute('aria-expanded', 'false');
      b.nextElementSibling.classList.remove('open');
    });
    // Open this one if it was closed
    if (!isOpen) {
      btn.setAttribute('aria-expanded', 'true');
      btn.nextElementSibling.classList.add('open');
    }
  });
});

// ── Free Shipping By (today, same-day) ───────────────────────
(function () {
  const el = document.getElementById('shipsDate');
  if (!el) return;
  const days   = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const d = new Date();
  const day = d.getDate();
  const suffix = [1,21,31].includes(day) ? 'st' : [2,22].includes(day) ? 'nd' : [3,23].includes(day) ? 'rd' : 'th';
  el.textContent = `${days[d.getDay()]}, ${months[d.getMonth()]} ${day}${suffix}`;
})();


// ── Sticky CTA: show when main panel-cta scrolls out of view ──
(() => {
  const main = document.getElementById("mainPanelCta");
  const sticky = document.getElementById("stickyCta");
  if (!main || !sticky) return;
  document.body.classList.add("has-sticky-cta");
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      sticky.classList.toggle("is-visible", !e.isIntersecting);
      sticky.setAttribute("aria-hidden", e.isIntersecting ? "true" : "false");
    });
  }, { threshold: 0.01 });
  io.observe(main);
})();


// ── Auto-cycling spotlight on composition cards (What's Inside tab) ──
(() => {
  const cards = document.querySelectorAll('#pane-benefits .composition-card');
  if (cards.length < 2) return;

  let idx = 0;
  let paused = false;
  let timer = null;

  const tick = () => {
    if (paused) return;
    cards.forEach((c, i) => c.classList.toggle('is-spotlight', i === idx));
    idx = (idx + 1) % cards.length;
  };

  const start = () => {
    tick();
    timer = setInterval(tick, 1800);
  };

  const stop = () => {
    if (timer) { clearInterval(timer); timer = null; }
    cards.forEach(c => c.classList.remove('is-spotlight'));
  };

  // Pause cycling when user hovers any card; resume on mouseleave
  cards.forEach(c => {
    c.addEventListener('mouseenter', () => { paused = true; cards.forEach(x => x.classList.remove('is-spotlight')); });
    c.addEventListener('mouseleave', () => { paused = false; });
  });

  // Only run while the "What's Inside" tab is active and visible
  const pane = document.getElementById('pane-benefits');
  if (!pane) return;

  // Start when pane scrolls into view, stop when out of view
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && pane.classList.contains('active') && !timer) start();
        else if (!e.isIntersecting && timer) stop();
      });
    }, { threshold: 0.2 });
    io.observe(pane);
  } else {
    start();
  }

  // Restart cycling when user re-clicks the "What's Inside" tab
  const benefitsBtn = document.querySelector('.tab-btn[data-tab="benefits"]');
  if (benefitsBtn) {
    benefitsBtn.addEventListener('click', () => {
      stop();
      setTimeout(start, 100);
    });
  }
  // Stop cycling when user clicks a different tab
  document.querySelectorAll('.tab-btn').forEach(btn => {
    if (btn.dataset.tab !== 'benefits') {
      btn.addEventListener('click', stop);
    }
  });
})();


// ── A/B variant passthrough ──
// Resolve the listicle variant from, in priority order:
//   1. the ?ab_variant= URL param set on the listicle CTA links (deterministic,
//      survives Meta/Instagram in-app browsers that drop cookies), then
//   2. the ab_first_chapter cookie set by the /the-first-chapter middleware
//      (fallback for direct visits to this offer page).
// Then tag Clarity and stamp ab_variant + utm_content onto every cart link so
// Shopify's customer journey records which variant the customer came from.
(() => {
  const param = new URLSearchParams(location.search).get('ab_variant');
  const cookie = (document.cookie.match(/(?:^|; )ab_first_chapter=([^;]+)/) || [])[1];
  const raw = param || cookie;
  const variant = raw === 'black' || raw === 'white' ? raw : null;
  if (!variant) return;

  // Tag this session in Clarity with the same variant
  if (typeof window.clarity === 'function') {
    window.clarity('set', 'ab_variant', variant);
    window.clarity('set', 'ab_test', 'first-chapter-listicle-redesign');
  }

  // Append ab_variant + utm_content to every cart link so Shopify captures it.
  // utm_content is the standard UTM that Shopify's customer journey definitely records.
  document.querySelectorAll('a[href*="/cart/"]').forEach(a => {
    try {
      const u = new URL(a.href);
      u.searchParams.set('ab_variant', variant);
      u.searchParams.set('utm_content', variant);
      a.href = u.toString();
    } catch (_) {}
  });
})();
